// Get environment variables with fallbacks
const getEnvVar = (key: string, fallback?: string): string => {
  const value = import.meta.env[`VITE_${key}`] || fallback
  if (!value) {
    throw new Error(`Missing environment variable: VITE_${key}`)
  }
  return value
}

// Define environment configuration
// Add/remove entries to match your project's API surface
export const env = {
  API_URL: getEnvVar('API_URL', 'http://localhost:8000/api/v1'),

  // DEMO-BRANCH ONLY (demo/2026-07-13): master switch for the mock-API layer.
  // Inert unless VITE_USE_MOCK_API=true is set (only .env.local on the demo
  // branch sets it). Remove together with src/lib/mock-api.ts — see
  // MOCK_API_HANDOVER.md at the repo root.
  USE_MOCK_API: import.meta.env['VITE_USE_MOCK_API'] === 'true',

  isDevelopment: import.meta.env['VITE_MODE'] === 'development',
  isProduction: import.meta.env['VITE_MODE'] === 'production',
} as const
